var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHidepassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.62917 4.33265C5.62192 3.68755 6.77223 3.20825 8 3.20825C10.79 3.20825 13.18 5.68328 14.23 6.95455C14.3958 7.16127 14.4876 7.42984 14.4876 7.70831C14.4876 7.98678 14.3958 8.25535 14.23 8.46207C13.6512 9.16282 12.6653 10.2293 11.4296 11.0455M9.5 11.978C9.01762 12.1238 8.51564 12.2084 8 12.2084C5.21 12.2084 2.82 9.73334 1.77 8.46207C1.60416 8.25535 1.51236 7.98678 1.51236 7.70831C1.51236 7.42984 1.60416 7.16127 1.77 6.95455C2.10267 6.55178 2.56985 6.02817 3.14165 5.50072",
    stroke: "#595A61",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.41421 9.12247C10.1953 8.34142 10.1953 7.07509 9.41421 6.29404C8.63316 5.51299 7.36684 5.51299 6.58579 6.29404",
    stroke: "#595A61",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 14.2083L1.5 1.20825",
    stroke: "#595A61",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHidepassword);
export default __webpack_public_path__ + "static/media/hidepassword.7cfb20ae678addcbfafa5c92341230d8.svg";
export { ForwardRef as ReactComponent };